import { render, staticRenderFns } from "./PatientComplaintsMan.vue?vue&type=template&id=79a9cee2&scoped=true"
import script from "./PatientComplaintsMan.vue?vue&type=script&lang=js"
export * from "./PatientComplaintsMan.vue?vue&type=script&lang=js"
import style0 from "./PatientComplaintsMan.vue?vue&type=style&index=0&id=79a9cee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a9cee2",
  null
  
)

export default component.exports